import { EyeOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { Text, Box } from 'atoms';
import { StatusAction } from 'components';
import { ACL } from 'components/common';
import { getLocalDate, getLocalTime } from 'utils/helpers';

export const ProjectTableConfig = [
	{
		title: 'Project Location Code',
		dataIndex: 'project_location_code',
		key: 'project_location_code',
		hidden: false,
		render: (project_location_code) => (
			<Text overFlow="hidden">{project_location_code || ''}</Text>
		),
	},
	{
		title: 'Client Name ',
		dataIndex: 'client_name',
		key: 'client_name',
		hidden: false,
		render: (client_name) => <Text overFlow="hidden">{client_name || ''}</Text>,
	},
	{
		title: 'Geo Location ',
		dataIndex: 'info',
		key: 'info',
		hidden: false,
		render: (info) => (
			<Text overFlow="hidden">{`${info?.latitude} ${info?.longitude}` || ''}</Text>
		),
	},
	{
		title: 'Reporting time',
		dataIndex: 'reporting_time',
		key: 'reporting_time',
		hidden: false,
		render: (reporting_time) => <Text overFlow="hidden">{reporting_time || ''}</Text>,
	},
	{
		title: 'Project Unique Code',
		dataIndex: 'project_unique_code',
		key: 'project_unique_code',
		hidden: false,
		render: (project_unique_code) => <Text overFlow="hidden">{project_unique_code || ''}</Text>,
	},
	{
		title: 'Created at',
		dataIndex: 'created_at',
		key: 'created_at',
		hidden: false,
		render: (created_at) => (
			<Box>
				<Text overFlow="hidden">{getLocalDate(created_at)}</Text>

				<Text overFlow="hidden" fontStyle="italic">
					{getLocalTime(created_at)}
				</Text>
			</Box>
		),
	},
	{
		title: 'View',
		dataIndex: 'id',
		key: 'id',
		hidden: false,
		render: (id) => (
			<Link to={`/projects/${id}`}>
				<EyeOutlined />
			</Link>
		),
	},
	{
		title: 'Action',
		dataIndex: 'id',
		key: 'id',
		hidden: false,
		render: (id, record) => (
			<ACL action="update" module="project">
				<StatusAction statusData={record?.is_active} userType="project" id={id} />
			</ACL>
		),
	},
];
